export default class StudentSelfEvaluationCheckRequest {
  listId;
  termId;
  constructor(data) {
    this.listId = data.listId;
    this.termId = data.termId;
  }
}
